<div class="campaigncharts" *ngIf="data != null">
    <div class="ui-g">

        <div class="ui-g-12 ui-md-4 ui-sm-12">
            <h2>{{ this.translations.segmentsInvoiceTitle }}</h2>
            <div class="chart-container">
                <chart [options]="segmentsInvoiceChart.options"
                       (load)="setChartInstance(segmentsInvoiceChart, $event.context)"></chart>
            </div>
        </div>

        <div class="ui-g-12 ui-md-8 ui-sm-12">
            <h2>{{ this.translations.segmentsInvoiceByDepartementTitle }}</h2>
            <div class="chart-container">
                <chart [options]="segmentsInvoiceByDepartementChart.options"
                       (load)="setChartInstance(segmentsInvoiceByDepartementChart, $event.context)"></chart>
            </div>
        </div>


    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/views/customerDB/customer-value/customer-division-expense/customer-division-expense.component.html